import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-helper, [helper]',
  templateUrl: './helper.component.html',
  styleUrls: ['./helper.component.scss']
})
export class HelperComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
